module.exports = __webpack_public_path__ + "img/Mask Group@2x2.a2b30033.jpg";